import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute
 * - If not logged in → redirect to /login
 * - If allowedRoles specified and user role not in list → redirect to their home or show AccessDenied
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading, userRole, getHomeRoute } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-500 text-lg">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    // Redirect to the user's allowed home
    return <Navigate to={getHomeRoute(userRole)} replace />;
  }

  return children;
};

export default ProtectedRoute;